import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { num } from "@/lib/format";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Check, Pencil } from "lucide-react";
import { toast } from "sonner";

export const ProducedQtyEdit = ({ product }) => {
  const qc = useQueryClient();
  const [edit, setEdit] = useState(false);
  const [val, setVal] = useState(product.produced_set ? product.produced_qty : "");
  const save = async () => {
    try {
      await api.patch(`/products/${product.id}`, { produced_qty: Math.max(0, parseInt(val || 0, 10)) });
      toast.success("Quantità prodotta salvata");
      qc.invalidateQueries({ queryKey: ["products"] });
      qc.invalidateQueries({ queryKey: ["activity-entity"] });
      setEdit(false);
    } catch { toast.error("Salvataggio non riuscito"); }
  };
  return (
    <div className="mt-2 flex items-center justify-between text-xs text-muted-foreground" data-testid={`produced-${product.sku}`}>
      <span>Prodotto</span>
      {edit ? (
        <span className="flex items-center gap-1">
          <Input type="number" min="0" value={val} onChange={(e) => setVal(e.target.value)} className="h-7 w-20 text-xs" data-testid={`produced-input-${product.sku}`} />
          <Button size="icon" variant="ghost" className="h-7 w-7" onClick={save} data-testid={`produced-save-${product.sku}`}><Check className="h-3.5 w-3.5" /></Button>
        </span>
      ) : (
        <button onClick={() => setEdit(true)} className="flex items-center gap-1 hover:text-foreground" data-testid={`produced-edit-${product.sku}`}>
          {product.produced_set ? <span className="font-semibold text-foreground">{num(product.produced_qty)} pz</span> : "da inserire"}
          <Pencil className="h-3 w-3" />
        </button>
      )}
    </div>
  );
};
